import { render, staticRenderFns } from "./SysSelect.vue?vue&type=template&id=4b606aa5&scoped=true&"
import script from "./SysSelect.vue?vue&type=script&lang=js&"
export * from "./SysSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b606aa5",
  null
  
)

export default component.exports